var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccumulatePoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.3333,
    stroke: "#00A3E0",
    strokeWidth: 1.33333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 23C21.3167 23 19.1458 22.5917 17.4875 21.775C15.8292 20.9583 15 20.0333 15 19C15 17.95 15.8292 17.0208 17.4875 16.2125C19.1458 15.4042 21.3167 15 24 15C26.6833 15 28.8542 15.4042 30.5125 16.2125C32.1708 17.0208 33 17.95 33 19C33 20.0333 32.1708 20.9583 30.5125 21.775C28.8542 22.5917 26.6833 23 24 23ZM24 28C21.5667 28 19.4583 27.6333 17.675 26.9C15.8917 26.1667 15 25.2833 15 24.25V21.75C15 22.4 15.3125 22.9625 15.9375 23.4375C16.5625 23.9125 17.3375 24.3042 18.2625 24.6125C19.1875 24.9208 20.1708 25.1458 21.2125 25.2875C22.2542 25.4292 23.1833 25.5 24 25.5C24.8333 25.5 25.7667 25.4292 26.8 25.2875C27.8333 25.1458 28.8125 24.925 29.7375 24.625C30.6625 24.325 31.4375 23.9375 32.0625 23.4625C32.6875 22.9875 33 22.4167 33 21.75V24.25C33 25.2833 32.1083 26.1667 30.325 26.9C28.5417 27.6333 26.4333 28 24 28ZM24 33C21.5667 33 19.4583 32.6333 17.675 31.9C15.8917 31.1667 15 30.2833 15 29.25V26.75C15 27.4 15.3125 27.9625 15.9375 28.4375C16.5625 28.9125 17.3375 29.3042 18.2625 29.6125C19.1875 29.9208 20.1708 30.1458 21.2125 30.2875C22.2542 30.4292 23.1833 30.5 24 30.5C24.8333 30.5 25.7667 30.4292 26.8 30.2875C27.8333 30.1458 28.8125 29.925 29.7375 29.625C30.6625 29.325 31.4375 28.9375 32.0625 28.4625C32.6875 27.9875 33 27.4167 33 26.75V29.25C33 30.2833 32.1083 31.1667 30.325 31.9C28.5417 32.6333 26.4333 33 24 33Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccumulatePoints);
export default __webpack_public_path__ + "static/media/accumulate-points.3b49602e05a36da27db1517522929e45.svg";
export { ForwardRef as ReactComponent };